import $ from 'jquery';

const $body = $('body');

const toggleOffcanvas = () => {
	$body.toggleClass('has-offcanvas');
};

$('.third-menu__toggle').on('click', toggleOffcanvas);